const specs = {
  // Design
  thickness: {
    name: "Espessura",
    tooltip: "Espessura da TV",
  },

  border: {
    name: "Borda",
  },

  singleConnection: {
    name: "Única Conexão",
    tooltip:
      "Apenas um fio fino conecta a TV a uma central de conexões externa - o One Connect",
  },

  displayMasterpiece: {
    name: "TV para obras primas",
    mobileName: "Para obras primas",
    tooltip:
      "TV que exibe uma galeria de obras de arte quando está em stand-by",
  },

  beautiful: {
    name: "Incondicionalmente bela",
    mobileName: "Toda bela",
    tooltip:
      "Design perfeito em 360° para colocar onde preferir: no rack, na parede ou no suporte de chão",
  },

  vertical: {
    name: "TV também na vertical",
    mobileName: "TV na vertical",
    tooltip:
      "Veja o conteúdo do seu celular adaptado na TV, rotacionando a tela verticalmente",
  },

  portable: {
    name: "Pra levar junto, portátil",
    mobileName: "Portátil",
    tooltip:
      "Design portátil, leve, com rotação de 180° e imagem de até 100 polegadas em resolução Full HD",
  },

  // Image
  resolution: {
    name: "Resolução",
    tooltip:
      "Imagem com contornos mais nítidos, texturas mais detalhadas e maior profundidade",
  },

  colorVolume: {
    name: "Painel & Volume de cor",
  },

  contrast: {
    name: "Contraste",
    tooltip:
      "Imagens com um preto mais preciso e brilho perfeito, trazendo muito mais realismo ao conteúdo",
  },

  brightness: {
    name: "Brilho",
    tooltip:
      "Imagens com brilho perfeito para a melhor experiência em ambientes mais claros",
  },

  processor: {
    name: "Processador",
    tooltip:
      "Proporciona a melhor experiência de visualização, aprimorando qualquer conteúdo",
  },

  frequency: {
    name: "Frequência do painel",
    tooltip:
      "Imagens rápidas e transições suaves com o painel com taxa de atualização de até 144Hz",
  },

  freesync: {
    name: "Freesync Premium Pro",
    tooltip:
      "Jogue seus jogos preferidos sem quebra de imagens e com suporte para conteúdos em HDR",
  },

  ultrawide: {
    name: "Super Ultra Wide",
    tooltip:
      "Tenha a melhor visualização do seu jogo com opções de formato de tela de 21:9 ou 32:9, além de um menu intuitivo para você consultar o input lag, FPS, HDR e muito mais",
  },

  gamingHub: {
    name: "Gaming Hub",
    tooltip:
      "Jogue direto na TV através da nuvem, sem a necessidade de um console",
  },

  hdmi: {
    name: "HDMI 2.1",
    tooltip:
      "Suporte HDMI para resolução e taxas de atualização mais elevadas, compatível com consoles e PC",
  },

  dolbyAtmos: {
    name: "Dolby Atmos",
    tooltip:
      "Padrão qualidade de som de cinema. Som imersivo e multidirecional",
  },

  movingSound: {
    name: "Som em movimento",
    tooltip: "Som que acompanha os objetos da cena",
  },

  soundPower: {
    name: "Potência",
  },

  smartThings: {
    name: "SmartThings",
    tooltip:
      "Controle sua casa através da TV, que administra os demais aparelhos inteligentes compatíveis e cria programações de acordo com a sua rotina",
  },

  alexa: {
    name: "Alexa em português",
    tooltip: "Controle sua TV por meio da Assistente de Voz Alexa",
  },

  bixby: {
    name: "Bixby em português",
    tooltip: "Controle a sua TV por meio da Assistente de Voz Bixby",
  },

  handsfree: {
    name: "Hands-free",
    tooltip:
      "Permite acionar o Assistente de Voz sem precisar utilizar o controle remoto",
  },

  googleduo: {
    name: "Google Duo",
    tooltip:
      "Faça reuniões utilizando a sua TV a partir do aplicativo de videochamadas do Google",
  },

  smartcam: {
    name: "Câmera inteligente",
    tooltip:
      "Câmera Inteligente que consegue rastrear a posição das pessoas para melhor enquadramento",
  },
};

export const mapping = {
  design: {
    name: "Design",
    specs: [
      'thickness',
      'border',
      'singleConnection',
      'displayMasterpiece',
      'beautiful',
      'vertical',
      'portable'
    ]
  },
  image: {
    name: "Imagem",
    specs: [
      'resolution',
      'colorVolume',
      'contrast',
      'brightness',
      'processor',
    ]
  },
  gaming: {
    name: "Jogos",
    specs: [
      'frequency',
      'freesync',
      'ultrawide',
      'gamingHub',
      'hdmi',
    ]
  },
  sound: {
    name: "Som",
    specs: [
      'dolbyAtmos',
      'movingSound',
      'soundPower',
    ]
  },
  connectivity: {
    name: "Conectividade",
    specs: [
      'smartThings',
      'alexa',
      'bixby',
      'handsfree',
      'googleduo',
      'smartcam',
    ]
  },
}

export default specs;